import { lazy } from "react";

import Header from "@/components/Header";

const HeroLazy = lazy(() => import("@/components/Hero"));
const ServiceLazy = lazy(() => import("@/components/Service"));
const PortfolioLazy = lazy(() => import("@/components/Portifolio"));
const AboutMeLazy = lazy(() => import("@/components/AboutMe"));
const CtaLazy = lazy(() => import("@/components/Cta"));
const FooterLazy = lazy(() => import("@/components/Footer"));

const Home = () => {
  return (
    <>
      <Header navegation={["Serviços", "Portfólio", "Sobre", "Contato"]} />
      <main>
        <HeroLazy />
        <ServiceLazy />
        <PortfolioLazy />
        <AboutMeLazy />
        <CtaLazy />
      </main>
      <FooterLazy />
    </>
  );
};

export default Home;
